var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertexit = function SvgAlertexit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64.001,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.38 51.754 29.54 1.416A2.842 2.842 0 0 1 32 0c1.015 0 1.953.54 2.46 1.416l29.16 50.338a2.823 2.823 0 0 1 0 2.83A2.842 2.842 0 0 1 61.16 56H2.84a2.842 2.842 0 0 1-2.46-1.415 2.823 2.823 0 0 1 0-2.831Z",
    fill: "#D82B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2F2",
    d: "M6.59 51.016 32 7.138l25.41 43.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39.603a1.638 1.638 0 0 1-1.64-1.485L29.13 25.01a2.875 2.875 0 0 1 .739-2.206c.546-.6 1.32-.942 2.131-.944a2.894 2.894 0 0 1 2.132.944c.547.6.814 1.4.738 2.206l-1.23 13.108A1.638 1.638 0 0 1 32 39.603Zm0 5.801c-.856 0-1.55-.692-1.55-1.545v-.468A1.557 1.557 0 0 1 32 41.846a1.557 1.557 0 0 1 1.55 1.545v.468c0 .41-.163.803-.453 1.093-.291.29-.685.452-1.097.452Z",
    fill: "#212121"
  }))));
};
export default SvgAlertexit;